// extracted by mini-css-extract-plugin
module.exports = {"liked":"PostCommentReplyLikeText_liked__ohwlU","like":"PostCommentReplyLikeText_like__1ei8w","reply":"PostCommentReplyLikeText_reply__274sD"};